import {
  getAllShippers, deleteShipper, updateShipper, newShipper,
} from '../shippers-service';
import { getMerchantCountries, getMerchantStates } from '../../../Settings/services/location';

export default {

  /**
   *
   * @param commit
   * @param page
   * @returns {Promise<void>}
   */
  async fetchAllShippers({ commit }) {
    const response = await getAllShippers();
    commit('setProperty', { property: 'shippers', payload: response });
  },

  /**
   *
   * @param {*} { dispatch }
   * @param {*} { shipperId }
   * @returns {Promise<void>}
   */
  async deleteShippers({ dispatch }, { shipperId }) {
    await deleteShipper(shipperId);
    dispatch('fetchAllShippers');
  },

  /**
   *
   * @param {*} context
   * @param {*} { shipperId, shipper }
   * @returns {Promise<void>}
   */
  async updateShipper({ dispatch }, { shipperId, shipper }) {
    await updateShipper(shipperId, shipper);
    dispatch('fetchAllShippers');
  },

  /**
   *
   * @param {*} context
   * @param {*} { shipper }
   * @returns {Promise<void>}
   */
  async createShipper({ dispatch }, { shipper }) {
    await newShipper(shipper);
    dispatch('fetchAllShippers');
  },
};
